import colors from '../../theme/foundations/colors'
import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'

export const headingText = {
    color: 'black',
    fontFamily: fonts.primary,
    letterSpacing: pxToRem(3),
    fontSize: {base: pxToRem(18), md: pxToRem(22)},
    lineHeight: 'normal',
    fontWeight: 600,
    fontStyle: 'normal',
    textTransform: 'uppercase'
}

export const subHeadingText = {
    color: 'black',
    fontFamily: fonts.primary,
    letterSpacing: pxToRem(1),
    fontSize: {base: pxToRem(14), md: pxToRem(16)},
    lineHeight: 'normal',
    fontWeight: 400,
    fontStyle: 'normal'
}

export const linkStyle = {
    color: 'cav_light_input_gray',
    fontFamily: fonts.primary,
    letterSpacing: pxToRem(1),
    fontSize: {base: pxToRem(12), md: pxToRem(13)},
    lineHeight: 'normal',
    fontWeight: 400,
    fontStyle: 'italic',
    textDecoration: 'underline'
}
